import InfoIcon from "../images/info.svg?react";

/**Default: 24px by 24px */
export default function CoreInfoIcon({
	height = 24,
	width = 24,
	color = "#42296E",
}: {
	width?: string | number;
	height?: string | number;
	/**@default "#42296E" */
	color?: string;
}) {
	return <InfoIcon width={width} height={height} color={color} role="presentation" />;
}
